(() => {
  if (window.CarouselUXSizeSelectionFix) return;
  window.CarouselUXSizeSelectionFix = true;

  document.addEventListener('click', event => {
    const sizeLabel = event.target.closest('.product-form__input--size .product-option__label[for]');
    if (!sizeLabel) return;

    const input = document.getElementById(sizeLabel.htmlFor);
    if (!input || input.disabled || input.classList.contains('disabled')) return;

    event.preventDefault();
    input.checked = true;

    const fieldset = input.closest('fieldset');
    const picker = input.closest('product-variant-selects');
    const selectedValue = fieldset?.querySelector('[data-selected-value]');
    if (selectedValue) selectedValue.textContent = input.value;

    if (picker) {
      const selectedOptions = [...picker.querySelectorAll('.product-form__input')]
        .map(group => group.querySelector('input:checked')?.value || group.querySelector('select')?.value)
        .filter(Boolean);
      const variantsElement = picker.querySelector('[data-all-variants]');
      let selectedVariant = null;

      try {
        const variants = JSON.parse(variantsElement?.textContent || '[]');
        selectedVariant = variants.find(variant =>
          variant.options.every((option, index) => option === selectedOptions[index])
        );
      } catch (_) {
        selectedVariant = null;
      }

      if (selectedVariant) {
        const productInfo = picker.closest('product-info');
        productInfo?.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]').forEach(variantInput => {
          variantInput.value = selectedVariant.id;
          variantInput.disabled = !selectedVariant.available;
        });
      }
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);
})();
